import { ELoanSystemId, type EFinancingProgram } from '@if/core/types'
import { can } from '@if/mui'
import type { SystemFlowConfig } from '@src/contexts/system-flow-context'

declare module '@if/mui' {
  interface IfFeatureFlags {
    useLoanDateOverrideInteracTransfers: boolean
    shutdownMonolith: boolean
  }
}

export const access = {
  overrideInteracTransferDate: can({ flag: 'useLoanDateOverrideInteracTransfers' }),

  openMonolithCalendar: can({ rule: ({ flags }) => !flags.shutdownMonolith }),

  generateValidationReport: can({
    permission: 'canExecuteDevTools',
    rule: ({ flags }) => !flags.shutdownMonolith,
  }),

  replayLoanMigrationEvents: can({ permission: 'canExecuteDevTools' }),

  openDevTools: can({ permission: 'canExecuteDevTools' }),

  forceUnlockLoan: can({ permission: 'canForceUnlockLoan' }),

  performChargeOff: can({ permission: 'canPerformChargeOff' }),

  performProductRefund: can({ permission: 'canPerformProductRefund' }),

  editLoansInLms: can<{ flowConfig: SystemFlowConfig; financingProgram: EFinancingProgram }>({
    rule: ({ flowConfig, financingProgram }) => {
      const config = flowConfig[financingProgram]
      if (!config) return true
      return config.readWrite === ELoanSystemId.LMS
    },
  }),
}
